export default "__VITE_ASSET__CAGNEYSM__"